import { MultiStepForm } from '@unistocks/components/form/multi-step-form';
import {
  DashboardItemSettings,
  MultiStepDashboardItemSettings
} from '@unistocks/features/dashboard/components/settings/dashboard-item-settings';
import { getDashboardItemDescriptor } from '@unistocks/features/dashboard/widget-registry';
import { DashboardItemDto, DashboardItemSettingsDto } from '@unistocks/proxy/axios-client';
import { t } from '@unistocks/shared/localization/index.ts';

export const renderSettingsForm = (item: DashboardItemDto, onClose: () => void) => {
  const descriptor = getDashboardItemDescriptor(item.type);
  const formId = `dashboard-item-settings-${item.id}`;
  const props = {
    formId,
    itemId: item.id,
    settings: descriptor.normalizeSettings?.(item.settings) ?? item.settings,
    onCancel: onClose
  };
  const schema = descriptor.schemaFactory();

  if (descriptor.settingsSteps.length === 1) {
    const [SettingsStep] = descriptor.settingsSteps;

    return (
      <DashboardItemSettings {...props} schema={schema}>
        <SettingsStep />
      </DashboardItemSettings>
    );
  }

  const [ContentStep, LayoutStep] = descriptor.settingsSteps;

  return (
    <MultiStepDashboardItemSettings
      {...props}
      strict={false}
      submitBehavior="submit"
      schema={schema}
    >
      <MultiStepForm.Step<DashboardItemSettingsDto> label={t('::Content')}>
        <ContentStep />
      </MultiStepForm.Step>
      <MultiStepForm.Step<DashboardItemSettingsDto> label={t('::Layout')}>
        <LayoutStep />
      </MultiStepForm.Step>
    </MultiStepDashboardItemSettings>
  );
};
